import html2canvas from 'html2canvas';

/**
 * Enum of all the possible pageType
 */
const PageType = {
  LANDING: 'LANDING',
  COMPARE: 'COMPARE',
  STANDARD: 'STANDARD',
  RT_MAX: 'RTMAX',
  RT_PLUS: 'RTPLUS',
};

const savedCanvas = {
  get: (pageType) => {
    sessionStorage.getItem(pageType);
  },
  [PageType.LANDING]: () => sessionStorage.getItem(PageType.LANDING)
    || localStorage.getItem(PageType.LANDING),
  [PageType.COMPARE]: () => sessionStorage.getItem(PageType.COMPARE)
    || localStorage.getItem(PageType.COMPARE),
  [PageType.STANDARD]: () => sessionStorage.getItem(PageType.STANDARD)
    || localStorage.getItem(PageType.STANDARD),
  [PageType.RT_MAX]: () => sessionStorage.getItem(PageType.RT_MAX)
    || localStorage.getItem(PageType.RT_MAX),
  [PageType.RT_PLUS]: () => sessionStorage.getItem(PageType.RT_PLUS)
    || localStorage.getItem(PageType.RT_PLUS),
};

/**
 * Create an image from a web page.
 * @param { PageType } pageType the type of the page?
 * @returns { Promise } resolve the generated image.
 */
const screenPage = pageType => new Promise((resolve) => {
  window.scrollTo(0, 0); // Go to top the page, for screen all page.
  html2canvas(document.body, {
    ignoreElements: element => element.id === 'blocHeader'
        || element.id === 'btnNext'
        || element.id === 'btnSend'
        || element.id === 'tutorialButtonrtPlus'
        || element.id === 'tutorialButtonrtMax'
        || element.id === 'tutorialButton'
        || element.tagName === 'NOSCRIPT',
    logging: false,
  }).then((canvas) => {
    const img = canvas.toDataURL('image/jpeg', 1);
    try {
      sessionStorage.setItem(pageType, img);
    } catch (err) {
      try {
        localStorage.setItem(pageType, img);
      } catch (error) {
        console.error('storage error:', error);
      }
    }
    // downloadBase64("seebase64", img); // You can use this for see the canvas
    resolve(img);
  });
});

const clearCanvas = () => {
  Object.keys(savedCanvas).forEach((key) => {
    sessionStorage.removeItem(key);
  });
};

export default {
  screenPage,
  clearCanvas,
};

export { PageType, savedCanvas };



// WEBPACK FOOTER //
// ./src/services/PDFService.js